import { ContentStateInterface } from '../../../../../../@types/types'
import { RealEstateAdditionalInformation } from '../../../../../../@types/real-estate-api-types'
import i18n from './../../../../../../i18next/i18n'
import { replaceControlCharacters } from '../../../../../../services/conversion/conversionServices'

export const additionalInformationToApi = (insertionData: ContentStateInterface): RealEstateAdditionalInformation => ({
  descriptionNote: replaceControlCharacters(insertionData.adDescription),
  locationNote: replaceControlCharacters(insertionData.adLocation),
  otherNote: addHomeStreetHomeIfApplicable(
    insertionData.isHomeStreetHomeEnabled,
    replaceControlCharacters(insertionData.adOther)
  ),
  furnishingNote: replaceControlCharacters(insertionData.adFurnishingNote),
})

function addHomeStreetHomeIfApplicable(homeStreetHomeEnabled: boolean | undefined, note: string | undefined) {
  if (!homeStreetHomeEnabled) {
    return note
  }
  const homeStreetHomeTag = i18n.t('wizard.screen.description.homeStreetHome.tag')
  if (!note) {
    return homeStreetHomeTag
  }
  if (note.indexOf(homeStreetHomeTag) < 0 && note.length < 2000 - homeStreetHomeTag.length) {
    return `${note}\n${homeStreetHomeTag}`
  }
  return note
}
